import { Box, Typography } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

/**
 * Small, persistent "AI-assisted — verify before relying" strip placed on
 * pages that surface AI-generated output (transactions, matches, review queue,
 * invoices, dashboard). Discrete by design — a constant reminder that the AI
 * requires human review, reinforcing the first-login acknowledgment.
 */
export function AiDisclaimer({ context }: { context?: string }) {
  return (
    <Box
      role="note"
      aria-label="AI human-review reminder"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 1.5,
        py: 0.75,
        mb: 2,
        borderRadius: 1.5,
        border: "1px solid var(--c-overlay-6)",
        background: "rgba(108,142,255,0.06)",
      }}
    >
      <AutoAwesomeIcon sx={{ fontSize: 16, color: "var(--c-link-accent)", opacity: 0.8 }} />
      <Typography variant="caption" sx={{ color: "var(--c-text-secondary)", lineHeight: 1.4 }}>
        <strong style={{ color: "var(--c-text-primary)" }}>AI-assisted.</strong>{" "}
        {context ?? "These results are generated by AI and can contain errors"} — always review and
        validate against the source documents before relying on them.
      </Typography>
    </Box>
  );
}

export default AiDisclaimer;
